import { Box, Button } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { useScreenSize } from '../../../sharedComponents/src/hooks/useScreenSize'

export const PuzzleQuestNavigation = () => {
    const navigate = useNavigate()
    const { isMobile } = useScreenSize()

    return (
        <Box
            display="flex"
            gap={1.5}
            justifyContent="center"
            alignSelf="center"
            sx={{ button: { px: 'unset' }, maxWidth: { xs: '600px', md: 'unset' }, width: '100%' }}
        >
            <Button
                color="primary"
                variant="contained"
                size={isMobile ? 'medium' : 'large'}
                fullWidth
                onClick={() => navigate('/daily-puzzle')}
            >
                Daily Puzzle
            </Button>
            <Button
                color="primary"
                variant="contained"
                size={isMobile ? 'medium' : 'large'}
                fullWidth
                onClick={() => navigate('/puzzles')}
            >
                Puzzle Practice
            </Button>
        </Box>
    )
}
